import React, { forwardRef } from 'react';
import ReactDatepicker from "react-datepicker";
import { ko } from "date-fns/locale";

import './DatePicker.scss'
import 'react-datepicker/dist/react-datepicker.min.css'
import style from './DatePicker.module.scss'

import Icon from "../Icon/Icon";

const CustomInput = forwardRef((props, ref) => {
    const { value, onClick, isDisabled, ...rest } = props;
    return (
        <div className={`${style.custom_datepicker} ${isDisabled ? style.isDisabled : ''}`}>
            <input
                type="text"
                onClick={isDisabled ? undefined : onClick}
                ref={ref}
                value={value}
                {...rest}
                disabled={isDisabled}
            />
            <button onClick={isDisabled ? undefined : onClick}>
                <Icon id="calendar_01" width="16" height="16" stroke={isDisabled ? "#BDBDBD" : "#212121"} />
            </button>
        </div>
    );
});

const CustomHeader = ({
                          date,
                          decreaseMonth,
                          increaseMonth,
                          prevMonthButtonDisabled,
                          nextMonthButtonDisabled,
                          changeYear,
                      }) => {
    const decreaseYear = () => changeYear(date.getFullYear() - 1);
    const increaseYear = () => changeYear(date.getFullYear() + 1);

    return (
        <div className={style.calendarHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <button onClick={decreaseYear} type="button" aria-label="Previous Year">
                {'<<'}
            </button>

            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} type="button" aria-label="Previous Month">
                {'<'}
            </button>

            <span>
        {`${date.getFullYear()}년 ${date.toLocaleString("default", { month: "long" })}`}
      </span>

            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} type="button" aria-label="Next Month">
                {'>'}
            </button>

            <button onClick={increaseYear} type="button" aria-label="Next Year">
                {'>>'}
            </button>
        </div>
    );
};

const DatePicker = props => {
    const {
        selDate,
        onChange,
        dateFormat = "yyyy.MM.dd",
        isDisabled = false
    } = props;

    const handleOnChange_ReactDatepicker = (date) => {
        onChange(date);
    };

    return (
        <div className={style.reactDatepicker_root}>
            <ReactDatepicker
                selected={selDate}
                onChange={handleOnChange_ReactDatepicker}
                locale={ko}
                dateFormat={dateFormat}
                customInput={<CustomInput isDisabled={isDisabled} />}
                renderCustomHeader={props => <CustomHeader {...props} />}
                calendarClassName={style.reactDatepickerCalendar}
                dayClassName={(date) => {
                    if (!selDate) {
                        return style.reactDatepickerDay;
                    }
                    return date.toDateString() === selDate.toDateString()
                        ? style.reactDatepickerDaySelected
                        : style.reactDatepickerDay;
                }}
                isDisabled={isDisabled}
            />
        </div>
    );
};

export default DatePicker;
